import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './utils/reset-queue'; // Load queue reset utilities
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA and Background Sync
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('SW registered:', registration);

      // Request persistent storage for offline queue
      if ('storage' in navigator && 'persist' in navigator.storage) {
        const persistent = await navigator.storage.persist();
        console.log('Persistent storage:', persistent);
      }

      // Register for Background Sync if supported
      if ('sync' in registration) {
        // Sync will be triggered by upload queue service
        console.log('Background Sync API supported');
      }

      // Listen for messages from service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data.type === 'GET_AUTH_TOKEN') {
          // Send auth token to service worker
          const token = localStorage.getItem('bfa_token');
          event.ports[0].postMessage({ token });
        } else if (event.data.type === 'SYNC_COMPLETE') {
          // Reload queue stats when sync completes
          console.log('Background sync completed at', new Date(event.data.timestamp));
          window.dispatchEvent(new CustomEvent('upload-queue-synced'));
        }
      });

    } catch (error) {
      console.log('SW registration failed:', error);
    }
  });
}